module.exports = __webpack_public_path__ + "static/media/Master.088833e1.svg";